/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Search_TitleInputs */

const en_pc_online_task_search_title = /** @type {(inputs: Pc_Online_Task_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the text`)
};

const zh_pc_online_task_search_title = /** @type {(inputs: Pc_Online_Task_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索文字`)
};

/**
* | output |
* | --- |
* | "Search the text" |
*
* @param {Pc_Online_Task_Search_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_search_title = /** @type {((inputs?: Pc_Online_Task_Search_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Search_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_search_title(inputs)
	return zh_pc_online_task_search_title(inputs)
});
export { pc_online_task_search_title as "pc.online.task.search.title" }